import { useEffect, useState } from 'react'

interface UseButtonLogicProps {
  isProcessingImage: boolean
  hasAIEraserCompleted: boolean
  hasVisualStagingCompleted: boolean
  hasEnhanceCompleted: boolean
  selectedAIFeature?: string
}

export const useButtonLogic = ({
  isProcessingImage,
  hasAIEraserCompleted,
  hasVisualStagingCompleted,
  hasEnhanceCompleted,
}: UseButtonLogicProps) => {
  const [canSave, setCanSave] = useState(false)

  // Determine if save button should be enabled
  useEffect(() => {
    if (isProcessingImage) {
      setCanSave(false)
      return
    }
    // Check if ANY tool has completed - this allows saving across flow switches
    // If user made changes in Virtual Staging and switches to Magic Eraser, they should still be able to save
    // This works for all flows: Virtual Staging, Magic Eraser, Enhance, Pintura, and any future flows
    const hasAnyCompletedChanges = hasAIEraserCompleted || hasVisualStagingCompleted || hasEnhanceCompleted

    setCanSave(hasAnyCompletedChanges)
  }, [hasAIEraserCompleted, hasVisualStagingCompleted, hasEnhanceCompleted, isProcessingImage])

  return {
    canSave
  }
}
